module.exports = __webpack_public_path__ + "img/42.474b66e8.gif";